// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2vmUW","large":"styles_large__TgLmL"};